import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePpPhaseMeta } from '../../hooks/usePpPhaseMeta';

// A blind phase user (ppPhaseEntry) keys pre-processing on the phase screens only;
// the lot-wide screens would hand them every other team's figures, and the server
// refuses them anyway. Sending them to their own screen beats a page of 403 toasts.
// `allowStages`: another stage that legitimately opens this page (the RM pool is
// procurement's screen too).
export default function PhaseBlindGate({ children, allowStages = [] }) {
  const { on, meta, loading } = usePpPhaseMeta();
  if (!on) return children;
  if (loading) return null;
  if (meta?.blind && !(meta.stages || []).some((s) => s !== 'preprocessing' && allowStages.includes(s))) {
    return <Navigate to="/preprocessing/phases" replace />;
  }
  return children;
}
